import { omit } from 'lodash'
import { DriverRegistrationRequest, ThumbType } from '~/shared/api'

export const uploadPhoto = async (
  blob: Blob,
  taxiparkId?: UniqueId,
): Promise<ThumbType> => {
  const uuid = await DriverRegistrationRequest.uploadMedia(blob, taxiparkId)
  const url = URL.createObjectURL(blob)

  return {
    uuid,
    previewUrlDownload: url,
    originalUrlDownload: url,
  }
}

export const omitValidationFields = <T extends Record<string, unknown>>(
  data: T,
): Omit<T, 'isIndividualEntrepreneur'> => {
  return omit(data, ['isIndividualEntrepreneur'])
}
